import { Trans } from '@lingui/react'

import { Flex } from '../flex'
import { Typography } from '../typography'

import { PaginationNavigation } from './pagination-navigation'

type Props = {
  page: number
  onPageChange: (page: number) => void
  rowsPerPage: number
  rowsCount: number
}

export const Pagination = ({
  page,
  onPageChange,
  rowsPerPage,
  rowsCount,
}: Props) => {
  const pageRangeTo = page * rowsPerPage
  const pageRangeFrom = pageRangeTo - rowsPerPage + 1
  const pagesNeeded = Math.ceil(rowsCount / rowsPerPage)

  return (
    <Flex alignItems="center" data-testid="pagination" justify="spaceBetween">
      <Typography color="textSecondary" variant="b3">
        <Trans
          id="pagination.pageRange"
          message="{rowsFrom}-{rowsTo} of {rowsTotal}"
          values={{
            rowsFrom: pageRangeFrom,
            rowsTo: Math.min(pageRangeTo, rowsCount),
            rowsTotal: rowsCount,
          }}
        />
      </Typography>
      <PaginationNavigation
        currentPage={page}
        pagesNeeded={pagesNeeded}
        onPageChange={onPageChange}
      />
    </Flex>
  )
}
